const globals = {
    // Constants
    backendPublicKeyRaw: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzH67cxzIY2fykcN1PaS1p5DjT2AwrNuF2CT8TtNlTwidixmEUrpNqU5HYXrt6uJNcof3hLUMor4gjvYA/M6tPVNRFEZLqDOR5ZWm6XeoeJQ/HtSNjt06utX/HvUSE89DsSa3244VmS6Q/KYq39171xTyy5lWlh9/60FcyGul/WK7A4MGDNjCc24SCcs4Z+27aobj1/OPDZNEhSEgYrzgw9LJbxQg4/Hd/9GpC9YkNW93717/07JcoBuTWMvHME7HUy5Np1At34pBjOs6xfm8htszZir0qd8MnTOQyPPcpwZhItM/dkVZsYa2Ua2rWVMMFhO2P993CXVFLl12IR93zwIDAQAB",
    serverUrl: process.env.NODE_ENV === 'production'
        ? 'https://towersbackend.azurewebsites.net/api/'
        : 'http://localhost:7029/api/',
    apiLogin: 'GmLogin?code=0xq2Ot2sUushdQ6tDk2VaAwcW8n8l9HC6lhd7gWEvr4oAzFuQ6BSew==',
    apiEntryPoint: 'GmEntryPoint?code=vvyH6A_tdXBzNxupU3MddnCqObsl0Iz91_ZPzHZEk8WhAzFurpafow==',
    languageNames: {
        "EN": "English", "PT": "Portuguese", "ID": "Indonesian", "KO": "Korean", "TR": "Turkish", "AZ": "Azerbaijani", "PL": "Polish",
        "FR": "French", "FA": "Persian", "HI": "Hindi", "AR": "Arabian", "VI": "Vietnamese", "ZH": "Chinese", "IT": "Italian",
        "TH": "Thai", "DE": "German", "ES": "Spanish", "RU": "Russian", "JA": "Japanese", "AF": "Afrikaans", "SQ": "Albanian",
        "BS": "Bosnian", "CA": "Catalan", "DA": "Danish", "SK": "Slovak", "SL": "Slovenian", "ET": "Estonian", "FI": "Finnish",
        "RO": "Romanian", "SV": "Swedish", "CS": "Czech", "UZ": "Uzbek", "ZU": "Zulu", "NL": "Dutch", "HU": "Hungarian", "LT": "Lithuanian",
        "MS": "Malay", "BE": "Belarusian", "BG": "Bulgarian", "KK": "Kazakh", "MK": "Macedonian", "MN": "Mongolian", "SR": "Serbian",
        "UK": "Ukrainian", "IW": "Hebrew", "MR": "Marathi"
    },
    platformNames: ["Android", "iOS", "Web", "Steam"],
    branches: ["Production", "Beta", "Internal", "Development"],
    branchFlags: {
        None:        0,
        Production:  1 << 0,
        Beta:        1 << 1,
        Internal:    1 << 2,
        Development: 1 << 3
    },

    // Vars
    loginData: {},
    privateKey: null,
    privateKeyDecrypt: null,
    backendPublicKey: null,
    backendPublicKeyEncrypt: null,
    selectedTitle: "",

    // Methods
    branchToFlags(branch) {
        switch(branch) {
            case "Production":
                return this.branchFlags.Production;
            case "Beta":
                return this.branchFlags.Beta;
            case "Internal":
                return this.branchFlags.Internal;
            case "Development":
                return this.branchFlags.Development;
            default:
                return this.branchFlags.None;
        }
    },

    addBranchFlags(flags, branch) {
        return flags | this.branchToFlags(branch);
    },

    removeBranchFlags(flags, branch) {
        return flags & ~this.branchToFlags(branch);
    },

    checkBranchFlags(flags, branch) {
        return (flags & this.branchToFlags(branch)) !== this.branchFlags.None;
    },

    setBranchFlags(branchArray) {
        let flags = this.branchFlags.None;
        for (const branch of branchArray) {
            flags |= this.branchToFlags(branch);
        }
        return flags;
    },

    compactVersion(major, minor, patch, branch = null) {
        if (branch == null) branch = 0;
        return ((branch & 0x3) << 29) | ((major & 0xFF) << 21) | ((minor & 0xFF) << 13) | (patch & 0x1FFF);
    },

    versionChangePatch(version, patch) {
        const { branch, major, minor } = this.decompactVersion(version);
        return this.compactVersion(major, minor, patch, branch);
    },

    decompactVersion(version) {
        const patch = version & 0x1FFF;
        const minor = (version >> 13) & 0xFF;
        const major = (version >> 21) & 0xFF;
        const branch = (version >> 29) & 0x3;
        return { branch, major, minor, patch };
    }
};

export default globals;